import React from "react";
import T from "prop-types";
import { update } from "MODULES/Lots/actions";
import { connect } from "react-redux";
import ConfirmAction from "../../../shared/components/ConfirmAction";

function ApproveLot({ approved, close, open, approveLot }) {
  if (approved) return null;

  return (
    <ConfirmAction
      onConfirm={() => approveLot()}
      close={close}
      open={open}
      btnClass="btn-danger"
      btnText="Yes, Approve Lot"
      icon={<i className="fa fa-fw fa-check" />}
    >
      <strong>Heads up!</strong>
      &nbsp; Are you sure you want to approve this order?
    </ConfirmAction>
  );
}

export default connect(undefined, dispatch => ({
  approveLot: () => dispatch(update({ approved: true }))
}))(ApproveLot);

ApproveLot.propTypes = {
  approveLot: T.func.isRequired,
  approved: T.bool,
  close: T.func,
  open: T.bool.isRequired
};



// WEBPACK FOOTER //
// ./app/modules/Lots/Detail/ApproveLot/ApproveLot.jsx